import { useEffect, useState } from 'react';
import { EventPublisher } from '../utils/publishEvent';
import { Tracker } from '../utils/trackers/trackers';
import { MetaTracker } from '../utils/trackers/meta/tracker';
import { TikTokTracker } from '../utils/trackers/tik-tok/tracker';

interface Pixel {
  trackerType: string;
  fields: {
    [key: string]: string[];
  };
}

export const extractAndUseTrackers = (
  data: Pixel[],
  isPuckLoaded: boolean,
  isGlobalPixel?: boolean,
  setPixelEvent?: React.Dispatch<
    React.SetStateAction<{
      isEventHoisted: boolean;
      phxRequestId: string;
    }>
  >,
  pixelEvent?: Tracker[],
  metaTickTokTracker: {
    meta: string[];
    tiktok: string[];
  } = { meta: [], tiktok: [] },
  pixelData?: string,
) => {
  const [trackers, setTrackers] = useState<{
    meta: string[];
    tiktok: string[];
  }>({
    meta: [],
    tiktok: [],
  });

  useEffect(() => {
    if (data) {
      data?.map((pixel: Pixel) => {
        if (pixel?.trackerType === 'Meta Pixel' && pixel?.fields['meta']) {
          const pixelIDs = pixel?.fields['meta']?.map(id => id?.trim());
          setTrackers(prev => ({
            ...prev,
            meta: pixelIDs,
          }));
        }
        if (pixel?.trackerType === 'TikTok Pixel' && pixel?.fields['tiktok']) {
          const pixelIDs = pixel.fields['tiktok']?.map(id => id?.trim());
          setTrackers(prev => ({
            ...prev,
            tiktok: pixelIDs,
          }));
        }
        return null;
      });
    }
  }, [data]);

  useEffect(() => {
    if (!pixelData) return;

    let isEvent = false;
    const newTrackers = {
      meta: trackers.meta,
      tiktok: trackers.tiktok,
    };
    let newPixelEvent: Tracker[] = [];
    if (isPuckLoaded) {
      if (
        data &&
        data.length &&
        (trackers.meta?.length || trackers.tiktok?.length)
      ) {
        if (isGlobalPixel) {
          newPixelEvent = [...(pixelEvent || [])];
          if (newTrackers?.meta?.length || metaTickTokTracker?.meta?.length) {
            newPixelEvent.push(
              new MetaTracker([
                ...newTrackers.meta,
                ...metaTickTokTracker.meta,
              ]),
            );
          }
          if (
            newTrackers?.tiktok?.length ||
            metaTickTokTracker?.tiktok?.length
          ) {
            newPixelEvent.push(
              new TikTokTracker([
                ...newTrackers.tiktok,
                ...metaTickTokTracker.tiktok,
              ]),
            );
          }
        } else {
          if (newTrackers?.meta?.length) {
            newPixelEvent.push(new MetaTracker([...newTrackers.meta]));
          }
          if (newTrackers?.tiktok?.length) {
            newPixelEvent.push(new TikTokTracker([...newTrackers.tiktok]));
          }
        }
      } else if (isGlobalPixel && (!data || (data && !data?.length))) {
        newPixelEvent = [...(pixelEvent || [])];
        if (metaTickTokTracker?.meta?.length) {
          newPixelEvent.push(new MetaTracker([...metaTickTokTracker.meta]));
        }
        if (metaTickTokTracker?.tiktok?.length) {
          newPixelEvent.push(new TikTokTracker([...metaTickTokTracker.tiktok]));
        }
      }
    }

    if (newPixelEvent && newPixelEvent?.length > 0) {
      const eventPublisher = EventPublisher.getInstance();
      newPixelEvent.forEach((tracker: Tracker) => {
        tracker.Init();
        eventPublisher.subscribeAll(event => {
          tracker.TrackEvent(event);
        });
      });
      isEvent = true;
    }
    if (setPixelEvent) {
      setPixelEvent(prev => ({
        ...prev,
        isEventHoisted: isEvent,
      }));
    }
  }, [
    trackers,
    pixelEvent,
    isGlobalPixel,
    pixelData,
    metaTickTokTracker,
    isPuckLoaded,
  ]);
};
